"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgLaptop(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M3 31h34", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0), (0, jsx_runtime_1.jsx)("rect", { x: 7, y: 9, width: 26, height: 18, rx: 1.895, stroke: "currentColor", strokeWidth: 2 }, void 0)] }), void 0));
}
exports.default = SvgLaptop;
//# sourceMappingURL=Laptop.js.map